import Course from "./Course";

export default Course;
